import { gql } from "@apollo/client";

export const donationToolQuery = gql`
  query DonationToolQuery($id: SweepstakesSlug!, $promoCodeName: String) {
    sweepstakes(id: $id) {
      id
      headline
      googleAdsConversionId
      paused

      slides {
        id
        image {
          publicId
          version
          cloudName
        }
      }

      nonprofit {
        id
        ein
        name
        paymentAccountId

        profile {
          id
          color
        }
      }

      donationLevels {
        id
        price
        level
        rewardTickets
      }

      schedule {
        id
        grace
      }

      activeSponsorCampaign {
        id
        url
        smallImage {
          publicId
          version
          cloudName
        }
        largeImage {
          publicId
          version
          cloudName
        }
      }

      activeThankYouCampaign {
        id
        smallImageUrl
        largeImageUrl
        promoCode {
          id
          name
        }
      }
    }

    promoCode(id: $id, name: $promoCodeName) {
      id
      name
      bonusPercent
    }
  }
`;

